import isValid from 'date-fns/isValid';
import addDays from 'date-fns/addDays';
import { useIntl } from 'react-intl-next';

import type { TrialDetailsQuery } from './__types__/TrialDetailsQuery';

const GRACE_PERIOD = 14; // days after trial ends for both HAMS and CCP

export const useLocalTrialEndDatesFromQuery = (queryData: TrialDetailsQuery | undefined) => {
	const intl = useIntl();

	const trialEndDateString = queryData?.license?.trialEndDate;

	// When the customer starts an instance, the exact timestamp of the trial end is not
	// recorded. We made the decision to always return the UTC date for `trialEndDate`.
	// We return the localized dates for display purpose
	const trialEndDate = trialEndDateString ? new Date(trialEndDateString) : null;

	if (!trialEndDate || !isValid(new Date(trialEndDate))) {
		return null;
	}

	const trialEndDateLong = intl.formatDate(trialEndDate, {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	});

	const trialEndDateShort = intl.formatDate(trialEndDate, {
		month: 'long',
		day: 'numeric',
		formatMatcher: 'best fit',
	});

	const deactivationDate = intl.formatDate(addDays(trialEndDate, GRACE_PERIOD), {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	});

	return {
		deactivationDate,
		trialEndDateShort,
		trialEndDateLong,
	};
};
